import React, { CSSProperties } from "react";

import { Colors } from "./theme";

interface Props {
  fill: string;
  height: number;
  width: number;
  style?: CSSProperties;
}

const IconCheck = ({ fill = Colors.primary, ...props }: Props) => (
  <svg
    height={18}
    viewBox="0 0 23 18"
    width={23}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.56 8.44a1.5 1.5 0 1 0-2.12 2.12l6.25 6.25a1.5 1.5 0 0 0 2.12 0L22.56 3.06A1.5 1.5 0 1 0 20.44.94L7.75 13.628l-5.19-5.19z"
      fill={fill}
      fillRule="nonzero"
    />
  </svg>
);

IconCheck.defaultProps = {
  height: 18,
  width: 23,
};

export default IconCheck;
